import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import VoucherForm from 'Component/DashboardQeza/Voucher/Form';
import { getVoucher } from 'Services/Features/Voucher/Utils/voucherUtils';
import { setFormData, resetFormData } from 'Services/Features/Voucher/voucherSlice';

const VoucherAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.voucher.filters)
    const currentVoucher = useSelector((state) => state.voucher.currentVoucher);

    // console.log(currentVoucher, 'currentVoucher');
    useEffect(() => {
        window.scrollTo(0, 0);

        if (id && !currentVoucher?.id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getVoucher(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photos & banner ke state terpisah
                    dispatch(setFormData({ bannerLink: item.banner }));

                    // Buat objek baru tanpa photos & banner
                    const { banner, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                    }));
                }
            });
        } else if (currentVoucher?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentVoucher,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id]);



    return (
        <Fragment>
            <Breadcrumbs parent="Voucher Perawatan" title={id ? 'Edit Voucher Perawatan' : 'Tambah Voucher'} />
            <VoucherForm label={id ? "" : "Voucher Baru"} />
        </Fragment>
    );
};
export default VoucherAdd;